import useMarzipano, { ViewerOpts, SceneSpec } from "../services/useMarzipano";

export interface GenerateMarzipanoViewProps {
  className?: string;
  style?: any;
  scene: Map<string, SceneSpec>;
  viewerOpts?: ViewerOpts;
}

export default function GenerateMarzipanoView({
  className,
  style,
  scene,
  viewerOpts,
}: GenerateMarzipanoViewProps): React.ReactElement {
  const { viewerCanvas } = useMarzipano({
    scenes: scene,
    viewerOpts,
  });

  return (
      <div
        className={className}
        style={{
          ...style,
        }}
        ref={viewerCanvas}
      />
  );
}
